import { NgModule } from '@angular/core'
import { TaiyuanCollegeSupervisionComponent } from './taiyuan-college-supervision.component'

@NgModule({
  declarations: [TaiyuanCollegeSupervisionComponent],
  imports: [],
  exports: [TaiyuanCollegeSupervisionComponent],
})
export class TaiyuanCollegeSupervisionModule {}
